import React from "react";
import FieldsAndBlocks from "./Scenes/FieldsAndBlocks/Controller";

const SimpleSideBar = ({ account }) => <FieldsAndBlocks account={account} />;

export default SimpleSideBar;
